import { Divider } from '@zorro/design-system/v2/Divider';
import { Stack, Text } from '@zorro/web/design-system';

type Props = {
  // The exact ordered, display-ready consent paragraphs recorded in the review snapshot —
  // the backend resolved everything (pediatric wording, spouse paragraphs, text cleanup);
  // null or empty (nothing recorded as shown) renders nothing.
  attestationParagraphs: string[] | null;
};

export const CarrierAttestations = ({ attestationParagraphs }: Props) => {
  if (!attestationParagraphs || attestationParagraphs.length === 0) {
    return null;
  }

  // Identical paragraphs are legitimate carrier text; suffix by occurrence so keys stay
  // unique and no paragraph is dropped from the consent block.
  const occurrences = new Map<string, number>();
  const keyedParagraphs = attestationParagraphs.map((paragraph) => {
    const occurrence = occurrences.get(paragraph) ?? 0;
    occurrences.set(paragraph, occurrence + 1);
    return { key: `${paragraph}-${occurrence}`, paragraph };
  });

  return (
    <>
      <Divider my="lg" />
      <Stack gap="md">
        {keyedParagraphs.map(({ key, paragraph }) => (
          <Text key={key} fz="0.875rem" style={{ whiteSpace: 'pre-wrap' }}>
            {paragraph}
          </Text>
        ))}
      </Stack>
    </>
  );
};
